import React from "react";
import { processSteps } from "../data";

export default function Process() {
  return (
    <section className="process" id="process">
      <div className="container">
        <div className="section-label">Как мы работаем</div>
        <h2 className="section-title">Ваш путь к новой улыбке: 4 прозрачных шага</h2>
        <p className="section-subtitle">
          Никаких «подводных камней» и сюрпризов. Вы всегда знаете, что происходит и сколько это стоит.
        </p>

        <div className="process-steps">
          {processSteps.map((s) => (
            <div key={s.num} className="process-step" data-testid={`process-step-${s.num}`}>
              <div className="process-num">{s.num}</div>
              <div className="process-title">{s.title}</div>
              <p className="process-text">{s.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
